"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.getLayoutParts = exports.isPinWithLayoutParts = void 0;
function isPinWithLayoutParts(pin) {
    return 'layoutParts' in pin.settings;
}
exports.isPinWithLayoutParts = isPinWithLayoutParts;
function getLayoutParts(pin) {
    if (isPinWithLayoutParts(pin)) {
        return pin.settings.layoutParts;
    }
    return {};
}
exports.getLayoutParts = getLayoutParts;
//# sourceMappingURL=layout-part.js.map